/* import __COLOCATED_TEMPLATE__ from './toggle-password-mask.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./toggle-password-mask.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());